import { navigate } from '../lib/route.ts'

/**
 * The two answer keys, side by side.
 *
 * They measure different steps and are shaped differently -- one is a page
 * read against labelled boxes, the other a product choice judged against a
 * catalogue -- but they answer the same question for a person: *is the system
 * getting this right?* Two menu entries would have made them look like
 * unrelated tools.
 *
 * Tabs navigate rather than swap status, so each set has an address that
 * survives a reload and can be sent to somebody.
 */
export function GoldenSetTabs({ active }: { active: 'reading' | 'resolution' }) {
  const tabs = [
    { key: 'reading' as const, label: 'Leitura', to: { name: 'goldenSet' as const } },
    { key: 'resolution' as const, label: 'Resolução', to: { name: 'resolutionSet' as const } },
  ]

  return (
    <div className="border-stroke-weak flex gap-1 border-b" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          onClick={() => navigate(tab.to)}
          className={
            active === tab.key
              ? 'text-tPSemi text-text-brand border-fill-brand -mb-px border-b-2 px-3 py-2'
              : 'text-tP text-text-weak hover:text-text-strong -mb-px border-b-2 border-transparent px-3 py-2'
          }
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
